module.exports = __webpack_public_path__ + "assets/img/mecha-btn-ab365194.png";